import React from "react";
import styles from "./input.module.css";
import { IoWarningOutline } from "react-icons/io5";

export enum InputValidationType {
  NOT_EMPTY = "NOT_EMPTY",
  TRUE = "TRUE",
}

export interface InputValidation {
  type: InputValidationType;
  title: string;
  options?: object;
}

export interface InputOptions {
  label: string;
  value: string;
}

export interface InputProps {
  title?: string;
  name?: string;
  type: InputType;
  required?: boolean;
  className?: string;
  value?: any;
  onChange?: (value: string) => void;
  label?: any;
  validations?: InputValidation[];
  errors?: string[];
  disabled?: boolean;
  options?: InputOptions[];
  inputComponent: any;
  onBlur?: (value: any) => void;
}

export enum InputType {
  TEXTAREA = "textarea",
  EDITOR = "editor",
  TEXT = "text",
  EMAIL = "text",
  NUMBER = "number",
  IMAGE = "image",
  PASSWORD = "password",
  CHECKBOX = "checkbox",
  TOGGLE = "toggle",
  TAGS = "tags",
  SELECT = "select"
}

export const Input = (props: InputProps) => {
  const {
    title,
    name,
    type,
    required,
    className,
    onChange,
    value,
    label,
    errors,
    disabled = false,
    options,
    inputComponent,
    onBlur
  } = props;

  const InputComponent = inputComponent;

  return (
    <div className={styles.input + (className ? " " + className : "")}>
      <div className={styles.input_header}>
        {title && <div className={styles.input_title}>{title}</div>}
        {required && <div className={styles.input_required}>*</div>}
      </div>
      <InputComponent
        className={styles.input_field + (type == InputType.TOGGLE ? ` ${styles.input_field_no_borders}` : '')}
        type={type}
        placeholder="Placeholder"
        onChange={onChange}
        value={value}
        label={label}
        disabled={disabled}
        options={options}
        onBlur={onBlur}
      />
      {errors && (
        <div className={styles.errors}>
          {errors.map((errorItem: any, i) => (
            <div className={styles.error} key={i}>
              <div className={styles.error_icon}>
                <IoWarningOutline />
              </div>
              <div className={styles.error_message}>{errorItem.title}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
